import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';
import { ComboboxOption } from '@headlessui/react';

import { CocoSharpText } from '../../../CocoSharpText/CocoSharpText';

const gradientAnimation = keyframes`
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
`;

export const AmeliaOption = styled(ComboboxOption)`
  width: 100%;
  background: var(--color-secondary-97);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--spacing-16) var(--spacing-16) var(--spacing-16)
    var(--spacing-24);
  border: none;
  font: var(--font-link-l);
  cursor: pointer;
  transition: all 0.3s;

  &:hover,
  &[data-focus] {
    background: var(--color-secondary-95);
  }

  &:focus {
    outline: none;
    background: var(--color-secondary-95);
  }
`;

export const Text = styled(CocoSharpText)`
  font-weight: 600;
`;

export const FakeButton = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  font: var(--font-label-l-bold);
  cursor: pointer;
  background: var(--color-white);
  border-radius: 1rem;
  padding: var(--spacing-8) var(--spacing-12);
  max-height: 32px;
  border: 2px solid transparent;
  background-image: linear-gradient(white, white),
    linear-gradient(to right, #ffed00, #ad5bff, #4a7dff);
  background-origin: border-box;
  background-clip: padding-box, border-box;
  background-size: 200% auto;
  transition: all 0.3s ease-in-out;

  &:hover {
    animation: ${gradientAnimation} 2s infinite linear;
  }
`;
